export default __webpack_public_path__ + "static/media/txt_entrance_06.bab44480.svg";